import React from 'react';
import { useTheme, FONT_SCALE_STEPS } from '../../context/ThemeContext';
import './FontSizeToggle.css';

export default function FontSizeToggle() {
  const { fontScale, increaseFontScale, decreaseFontScale } = useTheme();
  const stepIndex = FONT_SCALE_STEPS.indexOf(fontScale);

  return (
    <div className="font-toggle" role="group" aria-label="Adjust text size">
      <button
        type="button"
        className="font-toggle__btn"
        onClick={decreaseFontScale}
        disabled={stepIndex === 0}
        aria-label="Decrease text size"
        title="Decrease text size"
      >
        A<span className="font-toggle__sign">−</span>
      </button>

      <span className="font-toggle__dots" aria-hidden="true">
        {FONT_SCALE_STEPS.map((step, i) => (
          <span key={step} className={`font-toggle__dot ${i <= stepIndex ? 'font-toggle__dot--active' : ''}`} />
        ))}
      </span>

      <button
        type="button"
        className="font-toggle__btn"
        onClick={increaseFontScale}
        disabled={stepIndex === FONT_SCALE_STEPS.length - 1}
        aria-label="Increase text size"
        title="Increase text size"
      >
        A<span className="font-toggle__sign">+</span>
      </button>
    </div>
  );
}
